import React from 'react';
import classNames from 'classnames';

import classes from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className={classNames('level', classes.level)}>
          <div className="level-left" />
          <div className="level-right">
            <div className="level-item">
              © {new Date().getFullYear()} <span>&nbsp; Hd-Rain</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
